/**
 * Wildcard permission matching — mirrors the backend hasPermission logic exactly.
 *
 * Rules:
 *   '*'              in userPerms → global admin, matches everything
 *   exact string     → exact match
 *   'games.*.control' → '*' matches exactly one dot-segment
 *
 * Examples:
 *   hasPermission(['*'],               'server.power')             → true
 *   hasPermission(['games.*.control'], 'games.enshrouded.control') → true
 *   hasPermission(['games.*.control'], 'games.enshrouded.backup')  → false
 *   hasPermission(['games.*'],         'games.enshrouded')         → true
 *   hasPermission(['games.*'],         'games.enshrouded.control') → false
 */
export function hasPermission(userPerms: string[], required: string): boolean {
  if (userPerms.includes('*')) return true;
  if (userPerms.includes(required)) return true;
  const reqParts = required.split('.');
  return userPerms.some(perm => {
    const parts = perm.split('.');
    if (parts.length !== reqParts.length) return false;
    return parts.every((p, i) => p === '*' || p === reqParts[i]);
  });
}
